import { motion, useReducedMotion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1] as const;

/**
 * Subtle animated backdrop for dark hero sections.
 * Slow drifting gradient mesh + faint moving grid lines.
 */
const AmbientHeroBackdrop = () => {
  const reduce = useReducedMotion();

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
      {/* Faint grid */}
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(hsl(var(--seabed-foreground)) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--seabed-foreground)) 1px, transparent 1px)",
          backgroundSize: "64px 64px",
          maskImage:
            "radial-gradient(ellipse 70% 60% at 50% 30%, black 30%, transparent 80%)",
          WebkitMaskImage:
            "radial-gradient(ellipse 70% 60% at 50% 30%, black 30%, transparent 80%)",
        }}
      />

      {/* Drifting gradient mesh */}
      <motion.div
        className="absolute -inset-[20%]"
        initial={{ opacity: reduce ? 0.4 : 0.35, x: reduce ? 0 : "-3%", y: reduce ? 0 : "2%" }}
        animate={{
          opacity: reduce ? 0.4 : [0.35, 0.55, 0.35],
          x: reduce ? 0 : ["-3%", "3%", "-3%"],
          y: reduce ? 0 : ["2%", "-2%", "2%"],
        }}
        transition={{
          duration: 18,
          ease,
          repeat: Infinity,
        }}
        style={{
          background:
            "radial-gradient(ellipse 50% 40% at 30% 30%, hsl(var(--primary) / 0.18), transparent 70%), radial-gradient(ellipse 40% 35% at 75% 60%, hsl(var(--primary) / 0.10), transparent 70%)",
        }}
      />

      {/* Subtle scanline shimmer */}
      {!reduce && (
        <motion.div
          className="absolute inset-x-0 h-px"
          style={{
            background:
              "linear-gradient(90deg, transparent, hsl(var(--primary) / 0.5), transparent)",
          }}
          initial={{ y: "10%", opacity: 0 }}
          animate={{ y: ["10%", "90%", "10%"], opacity: [0, 0.5, 0] }}
          transition={{ duration: 8, ease: "linear", repeat: Infinity }}
        />
      )}
    </div>
  );
};

export default AmbientHeroBackdrop;
